const Config = {
  //url: "http://localhost:5000",
  url: "https://app.inieam.org.mx/backend",
}
export default Config;